export const PATH  = {
    LANDING: '/',
    EARLY_ACCESS: '/early-access',
    TERMS_OF_SERVICE: '/terms-of-service',
    PRIVACY_POLICY: '/privacy-policy',
    UNSUBSCRIBE: '/unsubscribe',
    PROJECT_BASE: '/:project_id/*', //:page_id?/:item_id?',
    USER_BASE: '/:project_id/user/*', //:user_id?',
    ADMIN_BASE: '/admin/*', //:page_id?/:item_id?',
}

export const HASH = {
    GNMODAL_ROADMAP: '#gn_roadmap_modal',
    GNMODAL_GNUSER: '#gn_gnuser_modal',
    GNMODAL_GNUSER_REMOVE: '#gn_gnuser_remove_modal',
    GNMODAL_GNDOCS: '#gn_gndocs_modal'
}